document.addEventListener('DOMContentLoaded', (event) => {
    var ctlbSwipes = new Swiper('.cgi .cgi-items__wrapper.swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        pagination: {
            el: '.cgi .swiper-pagination',
            clickable: true,
        },
        scrollbar: {
            el: '.cgi .swiper-scrollbar',
            draggable: true,
        },
        navigation: {
            nextEl: '.cgi .swiper-next-btn',
            prevEl: '.cgi .swiper-prev-btn',
        }
    });
});